export { default as TreeView } from 'locations/components/LocationsTreeView';



// WEBPACK FOOTER //
// src/modules/secured/modules/locations/components/index.js